<template>
  <v-container fluid>
    <PageHeading
      text="Действия"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    />
    <v-row>
      <v-col>
        <GridActionsDictionary
          ref="grid"
          @open-item="chosenActionItem = $event"
        />
      </v-col>
    </v-row>
    <ActionItemDialog
      v-if="chosenActionItem !== null"
      :item="chosenActionItem"
      @close="chosenActionItem = null"
    />
  </v-container>
</template>

<script>
import GridActionsDictionary from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'
import ActionItemDialog from '@/pages/actionsDictionary/actionItemDialog/ActionItemDialog'

export default {
  name: 'PageActionsDictionary',
  components: {
    ActionItemDialog,
    PageHeading,
    GridActionsDictionary
  },
  metaInfo () {
    return {
      title: 'Действия'
    }
  },
  mixins: [gridPageInterface],
  data () {
    return {
      chosenActionItem: null
    }
  }
}
</script>
